/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useMemo } from 'react'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import { useFormik } from 'formik'
import InputAdornment from '@material-ui/core/InputAdornment'
import CancelIcon from '@material-ui/icons/Cancel'
import Button from '@material-ui/core/Button'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { TranslationDictionary, useDisclosure } from '@plandi/common'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import Badge from '@material-ui/core/Badge'
import clsx from 'clsx'
import { ReactComponent as FilterIcon } from '../../assets/icons/filterIcon.svg'

import { useSearchBarStyles } from './search-bar.styles'
import { useSearchParam } from './use-search-param'
import { useQueryPrivateRequests } from './common/search-bar.query'
import { Box } from '@material-ui/core'
import { debounce, isEmpty } from 'lodash-es'
// import {useQuery} from "react-query";
// import {TRANSLATE} from "@plandi/shop/src/shared";

type SearchBarProps = {
  withButton?: boolean
  className?: string
  sticky?: boolean
  onSubmit?: (value?: string) => void
  onClear?: () => void
  invisibleBadge?: boolean
  searchType?: string
  styles?: React.CSSProperties
  withoutFilterIcon?: boolean
  forMobileAdaptive?: boolean
  setIsSearchBarClicked?: () => void
  modalStyles?: React.CSSProperties
  isDisabled?: boolean
  typeForSearch?: 'model' | 'project' | 'product'
  privateRequestStyle?: React.CSSProperties
  privateRequestButtonStyle?: React.CSSProperties
  translate?: TranslationDictionary['data']
}

export const SearchBar: React.FC<SearchBarProps> = (props) => {
  const classes = useSearchBarStyles()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const {
    searchPrivateRequests,
    keyword,
    setSearchParam,
    setSearchPrivateRequests
  } = useSearchParam()

  const { isOpen, onOpen, onClose } = useDisclosure()

  const { data: privateRequests } = useQueryPrivateRequests(
    searchPrivateRequests,
    props.typeForSearch
  )

  const formik = useFormik({
    initialValues: {
      keyword: keyword ?? ''
    },
    enableReinitialize: true,
    onSubmit: (value) => {
      props.onSubmit?.(value.keyword)
      setSearchPrivateRequests(value.keyword)
      setSearchParam(value.keyword)
    }
  })

  const handleClear = () => {
    formik.setFieldValue('keyword', '')
    setSearchParam(undefined)
    setSearchPrivateRequests('')
    props.onClear?.()
  }

  const onChangeInput = useMemo(
    () =>
      debounce((event) => {
        if (event.target.value && event.target.value.length >= 4) {
          setSearchPrivateRequests(event.target.value)
        } else {
          setSearchPrivateRequests('')
        }
      }, 800),
    [setSearchPrivateRequests]
  )

  const hasKeywordValue = formik.values.keyword.length > 0

  return (
    <div className={classes.hiddenBlock}>
      <form
        onSubmit={formik.handleSubmit}
        className={clsx(
          classes.root,
          props.className,
          classes[props.sticky ? 'sticky' : 'root']
        )}
        style={props.styles}
        onClick={props.setIsSearchBarClicked}
      >
        <TextField
          value={formik.values.keyword}
          onChange={(event) => {
            formik.setFieldValue('keyword', event.target.value)
            onChangeInput(event)
          }}
          focused={!props.setIsSearchBarClicked}
          name="keyword"
          className={classes.inputSearch}
          style={
            props.forMobileAdaptive
              ? { background: 'white', padding: 0, ...props.modalStyles }
              : { ...props.modalStyles }
          }
          fullWidth
          placeholder={props?.translate?.['job-site']['adverts-page']['search']}
          // placeholder="Поиск"
          size="small"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
            classes: { notchedOutline: classes.noBorder },
            endAdornment: (
              <>
                {hasKeywordValue && (
                  <InputAdornment
                    position="start"
                    onClick={handleClear}
                    className={classes.action}
                  >
                    <CancelIcon color="action" />
                  </InputAdornment>
                )}
                {!isDesktop && !props.withoutFilterIcon && (
                  <InputAdornment
                    position="start"
                    onClick={onOpen}
                    className={classes.action}
                  >
                    <Badge color="secondary" invisible={props.invisibleBadge}>
                      <FilterIcon />
                    </Badge>
                  </InputAdornment>
                )}
              </>
            )
          }}
        />

        {props.withButton && (
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            {props?.translate?.['job-site']?.['adverts-page']['search']}
          </Button>
        )}
        {isOpen && !isDesktop && (
          <Dialog
            open={isOpen}
            onClose={onClose}
            fullScreen
            className={props.searchType === 'models' ? classes.dialogModal : ''}
          >
            {props.searchType !== 'models' && (
              <DialogActions>
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </DialogActions>
            )}
            <DialogContent
              className={
                props.searchType === 'models' ? classes.dialogContent : ''
              }
            >
              {props.children}
            </DialogContent>
          </Dialog>
        )}
      </form>
      <Box className={classes.privateRequest} style={props.privateRequestStyle}>
        {!isEmpty(privateRequests) &&
          privateRequests?.data.map((item) => (
            <Button
              key={item.id}
              type="submit"
              className={classes.privateRequestButton}
              style={props.privateRequestButtonStyle}
              onClick={() => {
                formik.setFieldValue('keyword', item.search)
                formik.handleSubmit()
              }}
            >
              {item.search}
            </Button>
          ))}
      </Box>
    </div>
  )
}
